import {
  List, ClipboardList, CheckCircle2, Package, BarChart2, FileCheck,
  ShoppingCart, Receipt, Truck, ListTodo, ShieldCheck
} from "lucide-react";

// NOTA: "Caja Chica" y "Libro de Compras" se removieron de esta barra interna
// porque ya existen como módulos independientes en el sidebar
// (/compras/caja-chica y /compras/libro-compras). Los componentes
// CajaChicaTab.jsx y LibroComprasTab.jsx se conservan por compatibilidad.
export const TABS = [
  { id: "listas",          label: "Listas",           icon: List          },
  { id: "pedidos",         label: "Pedidos de Mat.",  icon: ClipboardList },
  { id: "aprobaciones",    label: "Aprobaciones",     icon: CheckCircle2  },
  { id: "ped_proveedores", label: "Ped. Proveedores", icon: Package       },
  { id: "analisis",        label: "Análisis Ppto.",   icon: BarChart2     },
  { id: "ptos_finales",    label: "Ptos. Finales",    icon: FileCheck     },
  { id: "ordenes",         label: "Ordenes de Compra",icon: ShoppingCart  },
  { id: "facturas",        label: "Facturas",         icon: Receipt       },
  { id: "retiro",          label: "Retiro / Entrega", icon: Truck         },
  // Fix CM (2026-09-13): tareas y flujo de trabajo del módulo de Compras.
  { id: "flujo",           label: "Tareas",           icon: ListTodo      },
  // Fix EX (2026-10-05): perfiles y rangos de monto para aprobar pedidos y análisis.
  { id: "rangos",          label: "Rango p/ Aprobaciones", icon: ShieldCheck },
];

export const FLOW_STEPS = [
  { key: "pendiente",             label: "Pendiente",      short: "PEND",    color: "#F59E0B" },
  { key: "aprobada",              label: "Aprobado",       short: "APROB",   color: "#10B981" },
  { key: "pedido_proveedor",      label: "Ped. Proveedor", short: "PED PROV",color: "#3B82F6" },
  { key: "analisis_presupuesto",  label: "Análisis Ppto.", short: "ANÁLISIS",color: "#8B5CF6" },
  { key: "presupuesto_aprobado",  label: "Ppto. Final",    short: "PTO APR", color: "#06B6D4" },
  { key: "oc_generada",           label: "OC Generada",    short: "OC",      color: "#2E6DA4" },
  { key: "facturado",             label: "Facturado",      short: "FACTURA", color: "#F97316" },
  { key: "retiro_materiales",     label: "Retiro",         short: "RETIRO",  color: "#84CC16" },
  { key: "entregado",             label: "Entregado",      short: "ENTREGA", color: "#22C55E" },
];

export const STATUS_COLORS = {
  // Fix S (2026-09-01): borrador, anterior a pendiente — color propio (slate,
  // punteado) para que nadie lo confunda con un pedido ya circulando.
  borrador:              "bg-slate-100 text-slate-600 border-slate-300 border-dashed",
  pendiente:             "bg-amber-100 text-amber-700 border-amber-200",
  aprobada:              "bg-emerald-100 text-emerald-700 border-emerald-200",
  rechazada:             "bg-red-100 text-red-700 border-red-200",
  modificar:             "bg-orange-100 text-orange-700 border-orange-200",
  pedido_proveedor:      "bg-blue-100 text-blue-700 border-blue-200",
  analisis_presupuesto:  "bg-purple-100 text-purple-700 border-purple-200",
  presupuesto_aprobado:  "bg-cyan-100 text-cyan-700 border-cyan-200",
  oc_generada:           "bg-[#2E6DA4]/10 text-[#2E6DA4] border-[#2E6DA4]/20",
  facturada:             "bg-orange-100 text-orange-700 border-orange-200",
  facturada_parcial:     "bg-amber-100 text-amber-800 border-amber-300",
  facturado:             "bg-orange-100 text-orange-700 border-orange-200",
  retiro_materiales:     "bg-lime-100 text-lime-700 border-lime-200",
  entregado:             "bg-emerald-100 text-emerald-700 border-emerald-200",
  pendiente_aprobacion:  "bg-orange-100 text-orange-700 border-orange-200",
  cancelada:             "bg-gray-100 text-gray-500 border-gray-200",
  seleccionada:          "bg-blue-100 text-blue-700 border-blue-200",
  no_seleccionada:       "bg-gray-100 text-gray-500 border-gray-200",
  completa:              "bg-emerald-100 text-emerald-700 border-emerald-200",
  con_discrepancia:      "bg-red-100 text-red-700 border-red-200",
  discrepancia:          "bg-red-100 text-red-700 border-red-200",
  pendiente_recepcion:   "bg-amber-100 text-amber-700 border-amber-200",
  cancelado:             "bg-gray-100 text-gray-500 border-gray-200",
  aprobado:              "bg-emerald-100 text-emerald-700 border-emerald-200",
  aprobado_parcial:      "bg-orange-100 text-orange-700 border-orange-200",
  rechazado:             "bg-red-100 text-red-700 border-red-200",
};

export const STATUS_LABELS = {
  borrador:             "Borrador",
  pendiente:            "Pendiente",
  aprobada:             "Aprobado",
  rechazada:            "Rechazado",
  modificar:            "A Modificar",
  pedido_proveedor:     "Ped. Proveedor",
  analisis_presupuesto: "Análisis Ppto.",
  presupuesto_aprobado: "Ppto. Aprobado",
  oc_generada:          "OC Generada",
  facturada:            "Facturada",
  facturada_parcial:    "Facturada parcial",
  facturado:            "Facturado",
  retiro_materiales:    "En Retiro",
  entregado:            "Entregado",
  pendiente_aprobacion: "Pend. Aprobación",
  cancelada:            "Cancelada",
  seleccionada:         "Seleccionada",
  no_seleccionada:      "No Seleccionada",
  completa:             "Completa",
  con_discrepancia:     "Con Discrepancia",
  discrepancia:         "Discrepancia",
  pendiente_recepcion:  "Pend. Recepción",
  cancelado:            "Cancelado",
  aprobado:             "Aprobado",
  aprobado_parcial:     "Aprobado Parcial",
  rechazado:            "Rechazado",
};

export const UNITS = ["m", "m²", "m³", "kg", "un", "rollo", "caja", "par", "juego", "gl"];

export const WORK_FRONTS = [
  "1. Media tensión",
  "2. Transformador / Generador",
  "3. Alimentación de tableros (NYY)",
  "3. Alimentación de tableros (multifilar)",
  "3. Alimentación de equipos (NYY)",
  "3. Alimentación de circuitos subterráneos (NYY)",
  "3. Alimentación de circuitos por bandejas (NYY)",
  "4. Tableros metálicos",
  "4. Tableros plásticos",
  "4. Protecciones",
  "4. Accesorios tableros",
  "4. Cableado para puentes",
  "5. Alimentación de circuitos (multifilar)",
  "5. Cajas y electroductos en hormigón (PEAD y PVC)",
  "5. Cajas y electroductos plástico (PVC)",
  "5. Cajas y electroductos frenados",
  "5. Soportería cajas y electroductos",
  "6. Bandeja portacable",
  "6. Soportería bandejas",
  "7. Artefactos de iluminación",
  "8. Mecanismos de encendido",
  "9. Sistema de puesta a tierra",
  "10. Señales débiles",
  "11. Herramientas y equipos de medición",
  "12. Equipamiento de seguridad",
  "13. Otros",
];

export const URGENCY_LABELS = { normal: "Normal", alta: "Alta", critica: "Crítico" };
